// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Russo_One_e86c02', '__Russo_One_Fallback_e86c02'","fontWeight":400,"fontStyle":"normal"},"className":"__className_e86c02"};